module.exports = __webpack_public_path__ + "img/diesel-locomotive-shadow-07.ad8260c5.png";